import SlidePanel, { FinalFocusRef } from './SlidePanel';

export interface SlidePanelProductInfoProps {
  id: string | number;
  image: string | null;
  title?: string;
  variantTitle?: string;
  subtitle?: string;
  description?: string;
  productId?: number | string;
  handle?: string;
  totalVariants?: number;
  images?: string[];
  hasOneVariant?: boolean;
  reviews?: Reviews;
  media?: Media[];
  finalFocusRef: FinalFocusRef;
}

export default SlidePanel;
